import React from "react";
import { Smartphone, ArrowRight } from "lucide-react";
import { whyApp } from "../content/landingContent";
import { Reveal } from "./Reveal";
import { useContentField, useContentList } from "../lib/useContent";

export const WhyApp: React.FC = () => {
  const title = useContentField("whyApp.title", whyApp.title);
  const text = useContentField("whyApp.text", whyApp.text);
  const extraText = useContentField("whyApp.extraText", whyApp.extraText);
  const benefits = useContentList("whyApp.benefitsList", whyApp.benefits);
  const closing = useContentField("whyApp.closing", whyApp.closing);
  return (
    <section
      id="por-que-app"
      data-testid="why-app-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-start">
        <Reveal>
          <span className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-motor-red">
            Capítulo 06
          </span>
          <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-[2.75rem] text-motor-ink leading-tight">
            {title}
          </h2>
          <p className="mt-5 text-base text-neutral-600 leading-relaxed">{text}</p>
          <p className="mt-4 text-base text-neutral-600 leading-relaxed">{extraText}</p>

          <div className="mt-8 rounded-2xl bg-motor-ink p-6 flex items-start gap-4">
            <Smartphone className="h-6 w-6 text-motor-gold shrink-0 mt-0.5" />
            <p className="font-display font-medium text-white leading-relaxed">{closing}</p>
          </div>
        </Reveal>

        <Reveal variant="right" delay={0.1}>
          <ul className="grid sm:grid-cols-2 gap-4">
            {benefits.map((b, idx) => (
              <li
                key={idx}
                data-testid={`why-app-benefit-${idx}`}
                className="flex items-start gap-3 rounded-xl border border-neutral-200 p-4"
              >
                <ArrowRight className="h-4 w-4 text-motor-red shrink-0 mt-1" />
                <span className="text-sm text-neutral-700">{b}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
